import { render, staticRenderFns } from "./DynamicIcon.vue?vue&type=template&id=50d30b1b&scoped=true&"
import script from "./DynamicIcon.vue?vue&type=script&lang=ts&"
export * from "./DynamicIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d30b1b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
